module.exports = __webpack_public_path__ + "static/media/deposit.d55db661.svg";